export const projects = [
  {
    img: "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd337b26121202b5bfb96d7_OriginalSize(1).png",
    title: "MYhours-Clone",
    des: "This is the clone of Myhours website. Free Time Tracking software with a track record. Time tracked on projects and tasks can be easily turned into shareable reports for your clients or managers",
    demo: "",
    live: "https://my-hourss.netlify.app/",
    gitHub: "https://github.com/shabh2412/inconclusive-stop-6058",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "Mongodb",
      "Express",
      "React",
      "Nodejs",
    ],
  },

  {
    img: "https://cdn.almowafir.com/1/Banggood-846x580.jpg",
    title: "Banggood-Clone",
    des: "This is the clone of Banggood website. Global Leading Online Shop. Buy 3d printer, rc toys, cell phones, home appliances, tv box, home&garden, apparel with great prices on banggood.com.",
    demo: "",
    live: " https://banggood-clone-masai.netlify.app/",
    gitHub: "https://github.com/Sneha052022/Banggood-Clone",
    technologies: ["HTML", "CSS", "JavaScript"],
  },
  {
    img: "https://freight.cargo.site/w/1254/i/f65c9590835785e9abf117b729ef81313123fc43e5b4e834580b91e851f18c4d/homepage.jpg",
    title: "Jcrew-Clone",
    des: "J.Crew Group, Inc., is an American multi-brand, multi-channel, specialty retailer. The company offers an assortment of women's, men's, and children's apparel and accessories, including swimwear, outerwear, lounge-wear, bags, sweaters, denim, dresses, suiting, jewelry, and shoes.",
    demo: "",
    live: "https://jcrewclone.netlify.app/",
    gitHub:
      "https://github.com/Sneha052022/timely-property-9028/tree/main/day5",
    technologies: ["HTML", "CSS", "JavaScript", "React"],
  },
];
